import './common/wdyr' // Developer tool to help understand why a component is rendering in non-production environments

import React, { useMemo } from 'react'
import { createBrowserRouter, LoaderFunction, RouterProvider } from 'react-router-dom'

import { ConfirmationPage } from '../pages/ConsumerAppointmentConfirmationPage/ConsumerAppointmentConfirmationPage'
import ConsumerEstimateReviewPage from '../pages/ConsumerEstimateReviewPage/ConsumerEstimateReviewPage'
import { ReviewEstimatePage } from '../pages/EstimatesFlow/CustomerExperience/ReviewEstimatePage'
import { ReviewInvoicePage } from '../pages/Invoices/CustomerExperience/ReviewInvoicePage'
import { QbdStatusPage } from '../pages/QbdStatusPage'
import { initializeDatadogRum } from '../providers/AnalyticsWrapper'
import { AppContextWrapper } from '../providers/AppContextWrapper'
import { NonAuthLaunchDarklyWrapper } from '../providers/LaunchDarklyWrapper'
import { NonAuthTrpcWrapper } from '../providers/NonAuthTrpcWrapper'
import { PlatformVersionWrapper } from '../providers/PlatformVersionWrapper'
import { NonAuthUrqlWrapper } from '../providers/UrqlWrapper'
import { Applications } from '../utils/application-type'
import { withApp } from './common/CommonAppWrapper'
import './AccountExperience.less'

import { AccountExperienceBookNowPage } from '../pages/AccountExperienceOnlineBookingPage/AccountExperienceOnlineBookingPage'
import { MaintenancePlanConfirmationPage } from '../pages/MaintenancePlanConfirmationPage/MaintenancePlanConfirmationPage'
import { ReadonlyCustomFormPage } from '../pages/ReadonlyCustomFormPage/ReadonlyCustomFormPage'

initializeDatadogRum()

const idLoader: LoaderFunction = ({ params }) => ({
  id: params.id,
})

const AccountExperienceApp = React.memo(() => {
  const router = useMemo(
    () =>
      createBrowserRouter([
        {
          path: '/',
          children: [
            {
              path: 'appointment-confirmation/:id',
              element: <ConfirmationPage />,
              loader: idLoader,
            },
            {
              path: 'estimate-review/:id',
              element: <ConsumerEstimateReviewPage />,
              loader: idLoader,
            },
            {
              path: 'estimate/:estimateGuid',
              element: <ReviewEstimatePage />,
            },
            {
              path: 'estimate/:estimateGuid/:contactGuid',
              element: <ReviewEstimatePage />,
            },
            {
              path: 'form/:appointmentChecklistInstanceId',
              element: <ReadonlyCustomFormPage />,
            },
          ],
        },
        {
          path: '/invoice/:invoiceGuid',
          element: <ReviewInvoicePage />,
        },
        {
          path: '/invoice/:invoiceGuid/:contactGuid',
          element: <ReviewInvoicePage />,
        },
        {
          path: '/book-now',
          element: <AccountExperienceBookNowPage />,
        },
        {
          path: '/maintenance-plan/:companyGuid/:maintenancePlanGuid',
          element: <MaintenancePlanConfirmationPage />,
        },
        {
          path: '/qbd-status/:companyGuid',
          element: <QbdStatusPage />,
        },
        {
          path: '*',
          element: <div>404. You might be lost</div>,
        },
      ]),
    [],
  )

  return <RouterProvider router={router} />
})

withApp(
  <NonAuthLaunchDarklyWrapper>
    <PlatformVersionWrapper>
      <NonAuthTrpcWrapper>
        <NonAuthUrqlWrapper>
          <AppContextWrapper appType={Applications.ACCOUNT}>
            <AccountExperienceApp />
          </AppContextWrapper>
        </NonAuthUrqlWrapper>
      </NonAuthTrpcWrapper>
    </PlatformVersionWrapper>
  </NonAuthLaunchDarklyWrapper>,
)
